(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    (function () {
    var sa = document.querySelector('shopify-account');
    if (!sa) return;

    /* --- Position: anchor popup below the profile icon ---
       CSS var chain underestimates position; set it directly from the element's rect.
       Also directly force the dialog top in the shadow DOM (mobile ignores the var). */
    function getHeaderBottom() {
      var rect = sa.getBoundingClientRect();
      return Math.round(Math.max(0, rect.bottom));
    }

    function applyDialogPosition() {
      var top = getHeaderBottom();
      sa.style.setProperty('--shopify-account-dialog-position-top', top + 'px');
      /* Force directly on shadow dialog — Shopify ignores the var on mobile */
      var sr = sa.shadowRoot;
      var dialog = sr && sr.querySelector('dialog');
      if (dialog && dialog.open) {
        dialog.style.setProperty('top', top + 'px', 'important');
        dialog.style.setProperty('bottom', 'auto', 'important');
        dialog.style.setProperty('margin', '0', 'important');
      }
    }

    window.addEventListener('resize', applyDialogPosition, { passive: true });
    window.addEventListener('scroll', applyDialogPosition, { passive: true });
    applyDialogPosition();

    /* --- Backdrop/outside click — closes the dialog on click OR touch ---
       showModal() traps all pointer events; we close when the hit is outside
       the dialog's content bounding rect. Works for mouse and touch. */
    function attachBackdropClose(dialog) {
      if (dialog.__backdropClose) return;
      dialog.__backdropClose = true;

      function closeIfOutside(x, y) {
        var rect = dialog.getBoundingClientRect();
        if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
          dialog.close();
        }
      }

      dialog.addEventListener('click', function (e) {
        closeIfOutside(e.clientX, e.clientY);
      });

      /* Touch: use touchstart so the close fires immediately on tap */
      dialog.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        if (t) closeIfOutside(t.clientX, t.clientY);
      }, { passive: true });
    }

    /* --- Safety net: open dialog if Shopify's promise stalls ---
       Also re-applies position immediately after opening. */
    sa.addEventListener('click', function () {
      setTimeout(function () {
        var sr = sa.shadowRoot;
        var dialog = sr && sr.querySelector('dialog');
        if (!dialog) return;
        attachBackdropClose(dialog);
        if (!dialog.open) {
          try { dialog.showModal(); } catch (e) {
            try { dialog.show(); } catch (e2) { /* silent */ }
          }
        }
        /* Apply position right after open so it's never in the wrong spot */
        requestAnimationFrame(applyDialogPosition);
      }, 150);
    });

    /* --- Shadow DOM patches ---
       1. Menu-content CSS: Shopify's <shopify-account> ships adopted stylesheets
          that cover dialog chrome but omit rules for .button.outline, .stack-inline,
          nav, svg — leaving SVGs at native viewBox size (360 × 360 px).
       2. Email form replacement: Hide the native email input and replace it with
          a "Sign in" button that redirects to the storefront login URL (Clerk OIDC). */

    var signInUrl = sa.getAttribute('sign-in-url') || '/account/login';

    function patchShadowDOM(sr) {
      if (sr.querySelector('[data-menu-patch]')) return;

      /* ---- Inject corrective CSS ---- */
      var style = document.createElement('style');
      style.setAttribute('data-menu-patch', '');
      style.textContent = [
        /* Close button — unstyled by Shopify, renders as raw browser default */
        '.account__close { position: absolute; top: 12px; right: 12px; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; background: none; border: none; border-radius: 50%; cursor: pointer; padding: 0; color: var(--shopify-account-color-text, #000); }',
        '.account__close:hover { background: rgba(0,0,0,0.06); }',
        '.account__close svg { width: 16px; height: 16px; }',
        /* Header needs relative positioning for the absolute close button */
        '.account__header { position: relative; padding: 20px 16px 8px; }',
        /* Content area — safe margins */
        '.account__content { padding: 0 16px 16px; }',
        /* Menu button layout */
        '.stack-inline { display: flex; flex-wrap: wrap; gap: 8px; padding: 8px 0; }',
        '.button.outline { display: inline-flex; align-items: center; gap: 8px; padding: 10px 16px; border: 1px solid rgba(0,0,0,0.15); border-radius: 8px; text-decoration: none; color: var(--shopify-account-color-text, #000); font-size: 14px; font-weight: 500; background: none; cursor: pointer; flex: 1; justify-content: center; }',
        '.button.outline:hover { background: rgba(0,0,0,0.04); }',
        '.button.outline svg { width: 20px; height: 20px; flex-shrink: 0; }',
        /* Hide the native <shopify-login-form> email input container */
        '.account__login-form-container { display: none !important; }',
        /* Clerk sign-in button — replaces the hidden email form */
        '.clerk-sign-in-btn { display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%; padding: 12px 16px; margin: 0 0 4px; border: none; border-radius: var(--shopify-account-radius-button, 8px); background: var(--shopify-account-color-accent, #000); color: var(--shopify-account-color-accent-text, #fff); font-size: 15px; font-weight: 600; font-family: var(--shopify-account-font-body, inherit); cursor: pointer; text-decoration: none; transition: opacity 0.15s ease; box-sizing: border-box; }',
        '.clerk-sign-in-btn:hover { opacity: 0.88; }',
        '.clerk-sign-in-btn svg { width: 18px; height: 18px; flex-shrink: 0; fill: currentColor; }',
        /* Force dialog to the top of the viewport (below the header icon), both mobile and desktop */
        'dialog { position: fixed !important; top: var(--shopify-account-dialog-position-top, 80px) !important; bottom: auto !important; margin: 0 auto !important; }'
      ].join('\n');
      sr.appendChild(style);

      /* ---- Replace email form with Clerk sign-in button ---- */
      replaceEmailForm(sr);
    }

    function replaceEmailForm(sr) {
      if (sr.querySelector('.clerk-sign-in-btn')) return;

      /* The email input lives inside <shopify-login-form> which is wrapped
         in .account__login-form-container. CSS hides that container; we
         insert a styled "Sign in" link before it that goes to Clerk OIDC. */
      var loginContainer = sr.querySelector('.account__login-form-container');
      if (!loginContainer) return;

      var btn = document.createElement('a');
      btn.href = signInUrl;
      btn.className = 'clerk-sign-in-btn';
      btn.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg> Sign in';
      loginContainer.parentNode.insertBefore(btn, loginContainer);
    }

    /* The shadowRoot may already exist or appear later; handle both cases. */
    if (sa.shadowRoot) {
      patchShadowDOM(sa.shadowRoot);
      var _d = sa.shadowRoot.querySelector('dialog');
      if (_d) { attachBackdropClose(_d); applyDialogPosition(); }
    }

    /* Re-check after the component hydrates (observer catches the shadowRoot
       being populated with menu content after the dialog first opens). */
    var observer = new MutationObserver(function () {
      if (sa.shadowRoot) {
        patchShadowDOM(sa.shadowRoot);
        /* Also observe inside shadowRoot for lazy-loaded form content */
        var dialog = sa.shadowRoot.querySelector('dialog');
        if (dialog) attachBackdropClose(dialog);
        if (dialog && !dialog.__observed) {
          dialog.__observed = true;
          new MutationObserver(function () {
            replaceEmailForm(sa.shadowRoot);
          }).observe(dialog, { childList: true, subtree: true });
        }
      }
    });
    observer.observe(sa, { childList: true, subtree: true });

    /* Also patch on first click, in case content loads lazily. */
    sa.addEventListener('click', function patchOnce() {
      setTimeout(function () {
        if (sa.shadowRoot) {
          patchShadowDOM(sa.shadowRoot);
          /* The form may load async after dialog opens — check again */
          setTimeout(function () { replaceEmailForm(sa.shadowRoot); }, 500);
          setTimeout(function () { replaceEmailForm(sa.shadowRoot); }, 1500);
        }
      }, 100);
      sa.removeEventListener('click', patchOnce);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
